export const I18N_STORAGE_KEY = 'locale';
export const VALIDATE_EMAIL = /^[A-Za-zd0-9]+([-_.][A-Za-zd0-9]+)*@([A-Za-zd0-9]+[-.])+[A-Za-zd]{2,5}$/;
export const VALIDATE_PASSWORD = /^(?=.*[A-Za-z])(?=.*[0-9])(.{8,})$/;

// 货币类型
export const CURRENCY_MAP = ['jpy', 'hkd'];

export const CAPTCHA_RCODE_SESSION_KEY = `${process.env.VUE_APP_ENV}_CAPTCHA_RCODE_SESSION_KEY`;
